import strFunc from '@/lib/lyg/string';
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';

function WriteArea(props: any) {
  let myProps = {
    rowData: {},
    setRowData: (inOptObj: any) => { },
    is_update: false,
    get_textbook_sort_by_ajax: (inOptObj: any) => { },
    sort1_arr: [],
    sort2_arr: [],
    sort3_arr: [],
    category_arr: [],
    set_category_arr: (inData: any) => { },
    set_sort1_arr: (inData: any) => { },
    set_sort2_arr: (inData: any) => { },
    set_sort3_arr: (inData: any) => { },
    //관리 팝업
    open_manage_textbook_sort_popup: (inData: any) => { },
    ...props
  };
  let rowData = myProps.rowData;
  let select_subject_arr = XcolumnFunc.getSortByTableKey({ 'table': 'study_title', 'key': 'a_subject_sort' });
  let product_info: any = {
    a_price: 0,
    a_price_tax: 0,
    a_stock_cnt: 0,
  };
  if (!strFunc.is_empty(rowData.product_info)) {
    product_info = rowData.product_info;
  }
  let product_info_use: any = {
    a_price: 0,
    a_stock_cnt: 0,
  };
  if (!strFunc.is_empty(rowData.product_info_use)) {
    product_info_use = rowData.product_info_use;
  }

  const handleInputChange = (event: any) => {
    const target = event.target;
    let value = target.value;
    const name = target.name;
    if (target.type === 'checkbox') {
      value = "";
      if (target.checked) {
        value = target.value;
      }
    }

    let chage_data_json: any = {
      [name]: value
    };


    if (name == "a_subject") {
      if (value != "") {
        myProps.get_textbook_sort_by_ajax({ s_type: "category", s_par_id: "subject", s_par_seq: value });
      }
      chage_data_json["a_category_seq"] = "";
      chage_data_json["a_sort1_seq"] = "";
      chage_data_json["a_sort2_seq"] = "";
      chage_data_json["a_sort3_seq"] = "";
      myProps.set_category_arr([]);
      myProps.set_sort1_arr([]);
      myProps.set_sort2_arr([]);
      myProps.set_sort3_arr([]);
    } else if (name == "a_category_seq") {
      if (value != "") {
        myProps.get_textbook_sort_by_ajax({ s_type: "sort1", s_par_id: "mtextbook_sort", s_par_seq: value });
      }
      chage_data_json["a_sort1_seq"] = "";
      chage_data_json["a_sort2_seq"] = "";
      chage_data_json["a_sort3_seq"] = "";
      myProps.set_sort1_arr([]);
      myProps.set_sort2_arr([]);
      myProps.set_sort3_arr([]);
    }
    if (name == "a_sort1_seq") {
      if (value != "") {
        myProps.get_textbook_sort_by_ajax({ s_type: "sort2", s_par_id: "mtextbook_sort", s_par_seq: value });
      }
      chage_data_json["a_sort2_seq"] = "";
      chage_data_json["a_sort3_seq"] = "";
      myProps.set_sort2_arr([]);
      myProps.set_sort3_arr([]);
    }
    if (name == "a_sort2_seq") {
      if (value != "") {
        myProps.get_textbook_sort_by_ajax({ s_type: "sort3", s_par_id: "mtextbook_sort", s_par_seq: value });
      }
      chage_data_json["a_sort3_seq"] = "";
      myProps.set_sort3_arr([]);
    }

    myProps.setRowData({
      ...rowData,
      ...chage_data_json
    });
  };

  const handleProductInputChange = (event: any) => {
    const target = event.target;
    let value = target.value;
    const name = target.name;

    if (name == "a_price" || name == "a_stock_cnt") {
      value = strFunc.comma(value);
    }

    let change_product_info: any = {
      ...product_info,
      [name]: value
    };

    myProps.setRowData({
      ...rowData,
      product_info: change_product_info
    });
  };

  const handleProductInputChangeUse = (event: any) => {
    const target = event.target;
    let value = target.value;
    const name = target.name;

    if (name == "a_price" || name == "a_stock_cnt" || name == "a_price_tax") {
      value = strFunc.comma(value);
    }

    let change_product_info: any = {
      ...product_info_use,
      [name]: value
    };

    myProps.setRowData({
      ...rowData,
      product_info_use: change_product_info
    });
  };

  return (
    <div className="write_table_small">
      <table>
        <colgroup>
          <col width="20%"></col>
          <col width="30%"></col>
          <col width="20%"></col>
          <col width="30%"></col>
        </colgroup>
        <tbody>
          <tr>
            <td colSpan={4} className="text-center">
              <select className="row-input" name="a_use_sort" value={rowData.a_use_sort}
                onChange={handleInputChange} style={{ width: 80 }} >
                <option value="study">교재</option>
                <option value="procedure">절차</option>
                <option value="coolen">브릿지영어</option>
                <option value="word_inside">내신영어</option>
                <option value="study_word">단어학습</option>
              </select>
              <select className="row-input ml-1" name="a_subject" value={rowData.a_subject}
                onChange={handleInputChange} style={{ width: 60 }}>
                <option value="">선택</option>
                {
                  select_subject_arr.map((item: any, idx: number) => {
                    return (
                      <option key={idx} value={item.value}>{item.text}</option>
                    );
                  })
                }
              </select>

              <select className="row-input ml-1" name="a_category_seq" value={rowData.a_category_seq}
                onChange={handleInputChange} style={{ width: 80 }} >
                <option value="">카테고리</option>
                {
                  myProps.category_arr.map((item: any, idx: number) => {
                    return (
                      <option key={idx} value={item.a_seq}>{item.a_title}</option>
                    );
                  })
                }
              </select>
              <select className="row-input ml-1" name="a_sort1_seq" value={rowData.a_sort1_seq}
                onChange={handleInputChange} style={{ width: 100 }}>
                <option value="">대분류</option>
                {
                  myProps.sort1_arr.map((item: any, idx: number) => {
                    return (
                      <option key={idx} value={item.a_seq}>{item.a_title}</option>
                    );
                  })
                }
              </select>
              <select className="row-input ml-1" name="a_sort2_seq" value={rowData.a_sort2_seq}
                onChange={handleInputChange} style={{ width: 100 }}>
                <option value="">중분류</option>
                {
                  myProps.sort2_arr.map((item: any, idx: number) => {
                    return (
                      <option key={idx} value={item.a_seq}>{item.a_title}</option>
                    );
                  })
                }
              </select>
              <select className="row-input ml-1" name="a_sort3_seq" value={rowData.a_sort3_seq}
                onChange={handleInputChange} style={{ width: 100 }}>
                <option value="">소분류</option>
                {
                  myProps.sort3_arr.map((item: any, idx: number) => {
                    return (
                      <option key={idx} value={item.a_seq}>{item.a_title}</option>
                    );
                  })
                }
              </select>
              <button className="ml-1 btn btn-dark"
                onClick={() => {
                  myProps.open_manage_textbook_sort_popup({
                    s_type: "sort3",
                    s_par_id: "mtextbook_sort",
                    s_par_seq: rowData.a_sort2_seq,
                  });
                }}>관리</button>
            </td>
          </tr>
          <tr>
            <th>제목</th>
            <td colSpan={3}>
              <input type="text" className="row-input" name="a_title" value={rowData.a_title} onChange={handleInputChange} placeholder="제목" />
            </td>
          </tr>
          <tr>
            <th>교재PDF주소</th>
            <td colSpan={3}>
              <input type="text" className="row-input" name="a_book_pdf_url" value={rowData.a_book_pdf_url}
                onChange={handleInputChange} placeholder="교재PDF주소" style={{ width: "70%" }} />
              {rowData.a_book_pdf_url != "" &&
                <span>
                  <button className="btn btn-dark ml-1 mt-1" onClick={() => {
                    let pdf_v_url = process.env.REACT_APP_API_URL + "/home/util/pdf_viewr";
                    pdf_v_url += "?pdf_url=" + rowData.a_book_pdf_url;
                    window.open(pdf_v_url);
                  }} >바로가기</button>
                </span>
              }
            </td>
          </tr>
          <tr>
            <th>페이지수</th>
            <td colSpan={3}>
              <input type="number" className="row-input" name="a_book_total_page" value={strFunc.uncomma(rowData.a_book_total_page)}
                style={{ width: "80px", textAlign: "right" }} placeholder="페이지수"
                onChange={handleInputChange}
                onClick={(e: any) => {
                  e.target.select();
                }} />
            </td>
          </tr>
          <tr>
            <th>교재정보</th>
            <td colSpan={3}>
              <div className='my_flex_center'>
                <span>
                  <label>
                    <input type="checkbox" className='row-input'
                      name="a_is_book" value="1" checked={rowData.a_is_book === "1"}
                      onChange={handleInputChange} />
                    교재여부
                  </label>
                </span>
                <span>
                  <label>
                    <input type="checkbox" className='row-input'
                      name="a_is_online" value="1" checked={rowData.a_is_online === "1"}
                      onChange={handleInputChange} />
                    온라인학습여부
                  </label>
                </span>
                <span>
                  <label>
                    <input type="checkbox" className='row-input'
                      name="a_is_able_order" value="1" checked={rowData.a_is_able_order === "1"}
                      onChange={handleInputChange} />
                    주문가능여부
                  </label>
                </span>
              </div>
            </td>
          </tr>
          {!strFunc.is_empty(rowData.a_answer_link_url) &&
            <tr>
              <th>답안지주소</th>
              <td colSpan={3}>
                <input type="text" className="row-input" name="a_answer_link_url" value={rowData.a_answer_link_url}
                  onChange={handleInputChange} placeholder="답안지주소" style={{ width: "70%" }} />
                {rowData.a_answer_link_url != "" &&
                  <span>
                    <button className="btn btn-dark ml-1 mt-1" onClick={() => { window.open(rowData.a_answer_link_url); }} >바로가기</button>
                  </span>
                }
              </td>
            </tr>
          }
          {rowData.a_use_sort == "coolen" &&
            <>
              {/* <tr>
              <th>부모구분</th>
              <td>
                <select className="row-input" name="a_par_id" value={rowData.a_par_id} onChange={handleInputChange} >
                  <option value="">선택</option>
                  <option value="contents_book">쿨잉글리시</option>
                  <option value="tts">TTS</option>
                </select>
              </td>
              <th>부모키</th>
              <td>
                <input type="text" className="row-input" name="a_par_seq" value={rowData.a_par_seq}
                  placeholder="부모키"
                  onChange={handleInputChange}
                  onClick={(e: any) => {
                    e.target.select();
                  }} />
              </td>
            </tr> */}
            </>
          }
          {(rowData.a_is_book == "1" || rowData.a_is_online == "1") &&
            <>
              {rowData.a_is_book == "1" &&
                <tr>
                  <th>가격</th>
                  <td>
                    <input type="text" className="row-input" name="a_price" value={strFunc.comma(product_info.a_price)}
                      onChange={handleProductInputChange} placeholder="가격" style={{ width: "80px", textAlign: "right" }}
                      onClick={(e: any) => { e.target.select(); }} />
                  </td>

                  <th>재고</th>
                  <td>
                    <input type="text" className="row-input" name="a_stock_cnt" value={strFunc.comma(product_info.a_stock_cnt)}
                      onChange={handleProductInputChange} placeholder="재고" style={{ width: "70px", textAlign: "right" }}
                      onClick={(e: any) => { e.target.select(); }} />
                  </td>
                </tr>
              }
              {rowData.a_is_online == "1" &&
                <tr>
                  <th>온라인</th>
                  <td colSpan={3}>
                    <input type="text" className="row-input" name="a_price" value={strFunc.comma(product_info_use.a_price)}
                      onChange={handleProductInputChangeUse} placeholder="가격" style={{ width: "100px", textAlign: "right" }}
                      onClick={(e: any) => { e.target.select(); }} />
                  </td>
                </tr>
              }
            </>
          }
        </tbody>
      </table>
    </div>
  );
};
export default WriteArea;